export const buildProvenance = { "commitHash": "b9e185d81f13f1241b683229a3eb20fc6ae35cc6", "branchName": "refs/heads/release/2023.3", "buildDate": "2023-11-05T12:38:41.919Z", "version": "2023.3.13159" };
